// Single source of truth for "am I running inside the native mobile app?"
// Used to gate billing UI: web → Paddle, Android → Google Play Billing.
import { Capacitor } from "@capacitor/core";

/** True when running inside the Capacitor native shell (Android/iOS). */
export function isNativeApp(): boolean {
  try {
    return Capacitor.isNativePlatform();
  } catch {
    return false;
  }
}

/** True only on Android native builds. iOS would use App Store IAP. */
export function isAndroidApp(): boolean {
  try {
    return Capacitor.isNativePlatform() && Capacitor.getPlatform() === "android";
  } catch {
    return false;
  }
}

/** True only on iOS native builds. */
export function isIosApp(): boolean {
  try {
    return Capacitor.isNativePlatform() && Capacitor.getPlatform() === "ios";
  } catch {
    return false;
  }
}
